import { render, staticRenderFns } from "./RemoveProjectAdmins.vue?vue&type=template&id=632ca3f6"
import script from "./RemoveProjectAdmins.vue?vue&type=script&lang=js"
export * from "./RemoveProjectAdmins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports